import { getObserver } from '@theme/theme-global';

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.mainAtcInView = false;
        this.footerInView = false;
        this.suppressedBySuccess = false;

        this.initVisibility();
        this.onSuccessShow = this.onSuccessShow.bind(this);
        this.onSuccessHide = this.onSuccessHide.bind(this);
        document.addEventListener('sticky-atc-success:show', this.onSuccessShow);
        document.addEventListener('sticky-atc-success:hide', this.onSuccessHide);
      }

      disconnectedCallback() {
        document.removeEventListener('sticky-atc-success:show', this.onSuccessShow);
        document.removeEventListener('sticky-atc-success:hide', this.onSuccessHide);
        if (this._buyButtonsTarget) this._visibilityObserver?.unobserve(this._buyButtonsTarget);
        if (this._footerTarget) this._visibilityObserver?.unobserve(this._footerTarget);
      }

      initVisibility() {
        const buyButtonsTarget = document.getElementById(this.dataset.buyButtonsId);
        const footerTarget = document.querySelector('footer.footer');

        if (!buyButtonsTarget && !footerTarget) return;

        this._buyButtonsTarget = buyButtonsTarget;
        this._footerTarget = footerTarget;
        this._visibilityObserver = getObserver({ threshold: 0 }, false, true);

        if (buyButtonsTarget) {
          this._visibilityObserver.observe(buyButtonsTarget, (entry) => {
            this.mainAtcInView = entry.isIntersecting;
            this.updateVisibility();
          });
        }

        if (footerTarget) {
          this._visibilityObserver.observe(footerTarget, (entry) => {
            this.footerInView = entry.isIntersecting;
            this.updateVisibility();
          });
        }
      }

      updateVisibility() {
        if (this.suppressedBySuccess || this.footerInView) {
          this.classList.remove('is-visible');
          return;
        }

        this.classList.toggle('is-visible', !this.mainAtcInView);
      }

      onSuccessShow() {
        this.suppressedBySuccess = true;
        this.updateVisibility();
      }

      onSuccessHide() {
        this.suppressedBySuccess = false;
        this.updateVisibility();
      }
    },
  );
}
